import * as actionTypes from './actionTypes';

export const establecerParametros = parameters => ({
  type: actionTypes.SET_SELECTED_PARAMETERS,
  payload: parameters
});